module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/assessment_achievements/4_13d44e952f8c1e2728607e67c31f67de.png";